import type { useShopsStatsTrafficQuery } from '@fourthwall/module-analytics'
import { SUMMARY_ROW_ID } from '@fourthwall/module-analytics'

import type { AnalyticsReportStatsTable } from '../AnalyticsReport.types'

export const createChartStatsTableUniqueVisitors = (
  data:
    | NonNullable<
        ReturnType<typeof useShopsStatsTrafficQuery>['shopsStatsTrafficQuery']['data']
      >['current']['uniqueVisitors']
    | undefined,
): AnalyticsReportStatsTable<any>['data'] => {
  if (!data) return []

  const statsTableData = data.data.timestamps.map((timestamp, index) => ({
    id: timestamp,
    day: timestamp,
    visitors: data.data.values[index],
  }))

  statsTableData.unshift({
    id: SUMMARY_ROW_ID,
    day: 'Summary',
    visitors: data.aggregatedValue || 0,
  })

  return statsTableData
}
